import { render } from "./kycFailed.vue?vue&type=template&id=e4ee5790&scoped=true&lang=true"
import script from "./kycFailed.vue?vue&type=script&lang=js"
export * from "./kycFailed.vue?vue&type=script&lang=js"

import "./kycFailed.vue?vue&type=style&index=0&id=e4ee5790&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ee5790"]])

export default __exports__